import { Observable } from 'rxjs';
import { Address, AddressDraft } from '../models/address/address.model';

/** Эндпоинта правки у бэкенда нет. */
export abstract class AddressesApi {
  abstract list(): Observable<Address[]>;
  abstract create(draft: AddressDraft): Observable<Address>;
  abstract remove(id: string): Observable<void>;
}
